import { getGridBackgroundStyles } from '@/utils';
import { Box, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useMedia } from '@/hooks/responsive';

import { getImageCardUrl } from '../../../../components/FileImageCard/utils';

export function FastCheckoutImage() {
	const image = useSelector(
		({ editor }) =>
			editor.images.find(item => item.id === editor.selectedImage) || {}
	);
	const mdDown = useMedia('mdDown');
	const imageUrl = getImageCardUrl({ pipeline: image });

	return (
		<Box
			sx={{
				py: 1,
				backgroundColor: 'neutral.150',
				borderRadius: '4px',
				display: 'flex',
				justifyContent: 'center'
			}}
		>
			<Stack>
				<Box
					sx={{
						width: { xs: 256, md: 360 },
						height: { xs: 256, md: 360 },
						...getGridBackgroundStyles(10),
						border: '2px solid',
						borderColor: 'divider',
						borderRadius: '4px',
						overflow: 'hidden'
					}}
				>
					<Box
						sx={{
							backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
							backgroundSize: 'cover',
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							width: '100%',
							height: '100%'
						}}
					/>
				</Box>

				{image?.originalFileName && mdDown && (
					<Typography
						variant="body0"
						color="text.secondary"
						sx={{ mt: '12px' }}
					>
						{image.originalFileName}
					</Typography>
				)}
			</Stack>
		</Box>
	);
}
